import { makeStyles } from "tss-react/mui"
import { getCategoryColors } from "../../../mp-core/themes/categoryColors"

type StylesParams = {
  category?: string
}

export const useStyles = makeStyles<StylesParams>()(
  ({ spacing, palette }, { category = "" }) => ({
    score: {
      display: "flex",
      alignItems: "center",
      gap: spacing(2)
    },
    scoreText: {
      color: getCategoryColors(undefined)?.primary,
      fontWeight: 500
    }
  })
)
